export default "__VITE_ASSET__CY24GxsU__"